export default __webpack_public_path__ + "6071a5cc598ceb57af72db17fe35d310.png";